import PropTypes from 'prop-types';
import { FiMinimize2 } from 'react-icons/fi';

import useScenariosByAnalysisId from '../../services/api/scenarios/useScenariosByAnalysisId';
import TypographyWithIcon from '../common/TypographyWithIcon';

export const AnalysisPrecision = ({ analysisId }) => {
    const { scenarios } = useScenariosByAnalysisId(analysisId);
    if (!scenarios) return null;
    const precision =
        scenarios.reduce(
            (total, scenario) => total + scenario.precision * scenario.score.wh.total,
            0
        ) / scenarios.reduce((whTotal, scenario) => whTotal + scenario.score.wh.total, 0);
    return (
        <TypographyWithIcon icon={<FiMinimize2 />}>
            Precision: {precision.toFixed(2)}%
        </TypographyWithIcon>
    );
};

AnalysisPrecision.propTypes = {
    analysisId: PropTypes.any,
};
